import React, { useState, useEffect } from "react";
import "../../Css/About.css";

function About() {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    fetch("https://api.gkaglobal.org/gkawebsite/aboutus.php")
      .then((response) => response.json())
      .then((result) => {
        if (result.aboutUs) {
          setAboutData(result.aboutUs);
        } else {
          console.error("Invalid data format", result);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  if (!aboutData) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <h1 className="about">About US</h1>

      <div className="container3">
        <h1 className="about1">{aboutData.title}</h1>

        {/* History Section */}
        <div className="Container1 mt-5">
          {aboutData.history &&
            aboutData.history.map((item, index) => (
              <div key={index} className="history-section">
                <p>{item.description}</p>
              </div>
            ))}
        </div>

        {/* Conventions Section */}
        {aboutData.conventions && (
          <div className="container4 mt-5">
            <h2 className="convo">Conventions History</h2>
            <div className="row">
              {aboutData.conventions.map((convention, index) => (
                <div key={index} className="col-md-6 col-sm-12 mb-4">
                  <div className="card2">
                    <img
                      src={convention.img}
                      className="card-img2-top custom-card2-img "
                      alt={convention.title}
                    />
                    <div className="card-body1">
                      <h5 className="card-title1">{convention.title}</h5>

                      {/* History Descriptions */}
                      {convention.history.map((event, eventIndex) => (
                        <p key={eventIndex}>
                          {event.description
                            .replace(/<\/?b>/g, "")
                            .split(/(Activities|TOLA)/g)
                            .map((word, index) =>
                              word === "Activities" || word === "TOLA" ? (
                                <strong key={index}>{word}</strong>
                              ) : (
                                word
                              )
                            )}
                        </p>
                      ))}

                      {/* Sub-Chapters Table (If Available) */}
                      {convention.history.some(
                        (event) => event.GKA_Sub_Chapters
                      ) &&
                        convention.history.map((event, eventIndex) =>
                          event.GKA_Sub_Chapters ? (
                            <div key={eventIndex} className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    {event.GKA_Sub_Chapters.headers.map(
                                      (header, idx) => (
                                        <th key={idx} className="table-header">
                                          {header}
                                        </th>
                                      )
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {event.GKA_Sub_Chapters.data.map(
                                    (row, rowIndex) => (
                                      <tr key={rowIndex}>
                                        <td className="table-cell">
                                          {row.Sub_Chapter}
                                        </td>
                                        <td className="table-cell">
                                          {row.When}
                                        </td>
                                        <td className="table-cell">
                                          {row.Representing_States}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : null
                        )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="vision_mission_content">
        <div className="container5">
          <div className="row">
            {/* Vision Section */}
            <div className="col-md-4 col-sm-6">
              <div className="vision_content">
                <div className="orange-strip1">&nbsp;</div>
                <h1 className="Res_Fnt">Our Vision</h1>
                <p>
                  Preserve Gujarati Kshatriya cultural and linguistic heritage
                  through diversity and sense of belonging for the future
                  generations.
                </p>
              </div>
            </div>

            {/* Mission Section */}
            <div className="col-md-4 col-sm-6">
              <div className="mission_content">
                <div className="orange-strip1">&nbsp;</div>
                <h1 className="Res_Fnt">Our Mission</h1>
                <p>
                  Preserve and promote Gujarati Kshatriya heritage by doing
                  cultural and social activities, marriage matrimonial, and
                  keeping the community informed to bring the community
                  together.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
